module.exports = __webpack_public_path__ + "img/btn_bg3.bd1deabf.png";